<template lang="pug">
  input.input-file(type="file" name="fileUpload" @change="onFileChange")
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'InputFile',
    props: {
      target: {
        type: String
      },
      action: {
        type: String,
        default: 'POST'
      },
      alias: {
        type: String
      },
      transportToParent: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        file: null
      }
    },
    methods: {
      emitter (event, data) {
        if (this.$props.transportToParent) {
          this.$parent.$emit(event, data)
        } else {
          this.$emit(event, data)
        }
      },
      uploadProgress (oEvent) {
        let vm = this;
        if (oEvent.lengthComputable) {
          let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
          vm.emitter('progress', percentComplete)
        } else {
          // Unable to compute progress information since the total size is unknown
          vm.emitter('progress', false)
        }
      },
      onFileChange (e) {
        let vm = this
        if (!this.target || this.target === '') {
          console.error('Please provide the target url')
        } else if (!this.action || this.action === '') {
          console.error('Please provide file upload action ( POST / PUT )')
        } else if (this.action !== 'POST' && this.action !== 'PUT') {
          console.error('File upload component only allows POST and PUT Actions')
        } else {
          let files = e.target.files || e.dataTransfer.files
          if (!files.length) {
            return
          }
          this.file = files[0]
          vm.emitter('fileChange', this.file)
        }
      },
      uploadFile (uploadObj) {
        if (!this.file) {
          console.error('nothing to upload')
        }
        let vm = this
        let formData = new FormData()
        Object.keys(uploadObj).map((key) => {
          formData.append(key, uploadObj[key])
        })
        formData.append(this.alias, this.file)

        axios.post(this.target,
          formData,
          {
            onUploadProgress: function (progressEvent) {
              vm.uploadProgress(progressEvent);
            }
          }
        ).then(function (result) {
          vm.emitter('finishUpload', result);
        }).catch(function (e) {
          vm.emitter('finishUpload', e);
        })
      }
    }
  }
</script>

<style lang="scss" src="./assets/input-file.scss"></style>
